import { SET_PRODUCTS } from "redux/reducers/products/productsReducer";
import { REQUEST_PRODUCTS } from "redux/reducers/products/productsReducer"
import { PROYECT } from "services/api"
import { api_get } from "services/api"

export const getProductsV2 = (id, token) => {
  const authUser = { headers: { authorization: `${token}` } };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/${id}/products`

  return async ( dispatch ) => {
    dispatch({ type: REQUEST_PRODUCTS })
    await api_get(url).then(resp => {
      dispatch({
        type: SET_PRODUCTS,
        payload: resp
      })
    })
  }
}